import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-425adf77"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "price-text"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"20px"} }, "合计", -1))
const _hoisted_3 = { class: "current-price" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"normal","font-size":"20px"} }, "￥", -1))
const _hoisted_5 = {
  key: 0,
  class: "discount-amount"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.priceData.current_price)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(_toDisplayString(_ctx.priceData.current_price / 100), 1)
        ]),
        (_ctx.priceData.current_price !== _ctx.priceData.origin_price)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 共优惠 ￥" + _toDisplayString((_ctx.priceData.origin_price - _ctx.priceData.current_price) / 100), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}